import type { CSSProperties } from 'react';

interface Styles {
    container: CSSProperties;
    listContainer: CSSProperties;
    itemSeparator: CSSProperties;
    emptyContainer: CSSProperties;
    emptyText: CSSProperties;
    txtHeader: CSSProperties;
    headerBottomSheet: CSSProperties;
    loadingMask: CSSProperties;
}

export const couponListStyles = (): Styles => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    listContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
    },
    itemSeparator: {
        height: 1,
        backgroundColor: '#eee',
    },
    emptyContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
    },
    emptyText: {
        fontSize: 14,
        color: '#999',
    },
    txtHeader: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 16,
    },
    headerBottomSheet: {
        borderBottom: '1px solid #eee',
        paddingBottom: 12,
    },
    loadingMask: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
    },
});
